import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  private cart: any;
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}
  setCart(cart) {
    localStorage.setItem('CS', JSON.stringify(cart));
    this.cart = cart;
  }
  getCart() {
    const cart = localStorage.getItem('CS');
    if (this.cart) {
      return this.cart;
    } else if (cart) {
      return JSON.parse(cart);
    }
  }

  getProductDetails(obj:any) {
    // https://qacms-uat.etisalat.ae/b2c/eshop/elife/getHomePlanProduct/elifeProd-unl-sports-1
    if(obj.commerceItemCategory){
      return this.http.get(
        `${environment.BASE_URL}/getProduct/`+obj.productId,
        this.httpOptions
      );
    }else if(obj.commerceItemType == 'etsElifeSku'){
      return this.http.get(
        `${environment.BASE_URL}/elife/getHomePlanProduct/`+obj.productId,
        this.httpOptions
      );
    }else{
    return this.http.get(
      `${environment.BASE_URL}/getPostPaidPlanProduct/`+obj.productId,
      this.httpOptions
    );
    }
  }

  getShoppingCart() {
    return this.http.get(
      `${environment.BASE_URL}/getShoppingCart`,
      this.httpOptions
    );
  }

  addToShoppingCartOneByOne(payload) {
    return this.http.post(
      `${environment.BASE_URL}/addToShoppingCartOneByOne`,
      payload,
      this.httpOptions
    );
  }

  updateItemToShoppingCartOneByOne(payload) {
    return this.http.post(
      `${environment.BASE_URL}/updateItemToShoppingCartOneByOne`,
      payload,
      this.httpOptions
    );
  }

  deleteItemFromCart(payload) {
    return this.http.post(
      `${environment.BASE_URL}/deleteItemFromCart`,
      payload,
      this.httpOptions
    );
  }

  deleteItemsFromCartOneByOne(payload) {
    return this.http.post(
      `${environment.BASE_URL}/deleteItemsFromCartOneByOne`,
      payload,
      this.httpOptions
    );
  }

  updateItemsQuantityInCart(payload) {
      return this.http.put(
        `${environment.BASE_URL}/updateItemsQuantityInCart`,
        payload,
        this.httpOptions
      );
  }

  validateCoupon(payload) {
    return this.http.post(
      `${environment.BASE_URL}/validateCoupon`,
      payload,
      this.httpOptions
    );
  }

  addPromoCode(payload){
    return this.http.post(`${environment.BASE_URL}/addPromoCode`,payload,this.httpOptions)
  }

  removePromoCode(payload){
    return this.http.post(`${environment.BASE_URL}/removePromoCode`,payload,this.httpOptions)
  }
  getShoppingCartNotifications() {
    return this.http.get(
      `${environment.BASE_URL}/getShoppingCartNotifications`,
      this.httpOptions
    );
  }
  optimizeinventory() {
    return this.http.get(
      `${environment.BASE_URL}/optimizeinventory`,
      this.httpOptions
    );
  }

  savePromotionalConsent(payload){
    this.httpOptions.headers.append('Accept', 'application/json');
    return this.http.post(`${environment.BASE_URL}/commerceitems/save/consent`,payload,this.httpOptions)
  }

  getGroupedCommerceItems(shoppingCart: any) {
    var groupedCommerceItems = [];
    if (shoppingCart.items && shoppingCart.items.length > 0) {
      shoppingCart.items.forEach((commerceItem) => {
        let group: any;
        if (
          commerceItem &&
          commerceItem.paymentOptions &&
          commerceItem.paymentOptions.id == '-1' &&
          commerceItem.addons === undefined &&
          commerceItem.isProduct &&
          commerceItem.commerceItemType === 'mobileDevicesSku'
        ) {
          // if (groupedCommerceItems.length > 0) {
          //   var commerceItemGroupIndex = -1;
          //   for (var i = 0; i < groupedCommerceItems.length; i++) {
          //     if (
          //       groupedCommerceItems[i].commerceItems[0].paymentOptions &&
          //       groupedCommerceItems[i].commerceItems[0].paymentOptions.id ==
          //         '-1' &&
          //       groupedCommerceItems[i].commerceItems[0].skuId ==
          //         commerceItem.skuId
          //     ) {
          //       commerceItemGroupIndex = i;
          //     }
          //   }
          //   if (commerceItemGroupIndex != -1) {
          //     groupedCommerceItems[commerceItemGroupIndex].commerceItems.push(
          //       commerceItem
          //     );
          //     groupedCommerceItems[commerceItemGroupIndex].quantity =
          //       groupedCommerceItems[
          //         commerceItemGroupIndex
          //       ].commerceItems.length;
          //   } else {
          //     group = { commerceItems: [], quantity: 0 };
          //     group['commerceItems'] = [];
          //     group.commerceItems.push(commerceItem);
          //     group['quantity'] = group.commerceItems.length;
          //     groupedCommerceItems.push(group);
          //   }
          // } else {
            group = { commerceItems: [], quantity: 0 };
            group.commerceItems.push(commerceItem);
            group['quantity'] = group.commerceItems.length;
            groupedCommerceItems.push(group);
          // }
        } else {
          group = { commerceItems: [], quantity: 0 };
          group.commerceItems.push(commerceItem);
          group['quantity'] = group.commerceItems.length;
          groupedCommerceItems.push(group);
        }
      });
    }

     groupedCommerceItems = groupedCommerceItems.map(a=>{
      const length = a.commerceItems.length || 0;
      if(a.commerceItems.length > 0){
        a.commerceItems = [{...a.commerceItems && a.commerceItems[0]}] || [];
        a.commerceItems[0].quantity = length;
      }
      return a;
     });
    return groupedCommerceItems;
  }

  getElifeBannerbannerUrl(bannerUrl) {
    if (bannerUrl) {
      const channel = 'portal';
      bannerUrl = channel + bannerUrl;
      bannerUrl = this.UTS.getLocaleLanguage() + bannerUrl;
    }
    return bannerUrl;
  }

  getGroupedCommerceItemsReview(shoppingCart: any) {
    let groupedCommerceItems = [];
    let data = {items:[],shipDateAndTime:{}}
    if (shoppingCart.items && shoppingCart.items.length > 0) {
      shoppingCart.items.forEach((commerceItem) => {
        let group: any;
        if (
          commerceItem &&
          commerceItem.paymentOptions &&
          commerceItem.paymentOptions.id == '-1' &&
          commerceItem.addons === undefined &&
          commerceItem.isProduct &&
          commerceItem.commerceItemType === 'mobileDevicesSku'
        ) {
          // if (groupedCommerceItems.length > 0) {
          //   var commerceItemGroupIndex = -1;
          //   for (var i = 0; i < groupedCommerceItems.length; i++) {
          //     if (
          //       groupedCommerceItems[i].commerceItems[0].paymentOptions &&
          //       groupedCommerceItems[i].commerceItems[0].paymentOptions.id ==
          //         '-1' &&
          //       groupedCommerceItems[i].commerceItems[0].skuId ==
          //         commerceItem.skuId
          //     ) {
          //       commerceItemGroupIndex = i;
          //     }
          //   }
          //   if (commerceItemGroupIndex != -1) {
          //     groupedCommerceItems[commerceItemGroupIndex].commerceItems.push(
          //       commerceItem
          //     );
          //     groupedCommerceItems[commerceItemGroupIndex].quantity =
          //       groupedCommerceItems[
          //         commerceItemGroupIndex
          //       ].commerceItems.length;
          //   } else {
          //     group = { commerceItems: [], quantity: 0 };
          //     group['commerceItems'] = [];
          //     group.commerceItems.push(commerceItem);
          //     group['quantity'] = group.commerceItems.length;
          //     groupedCommerceItems.push(group);
          //   }
          // } else {
            group = { commerceItems: [], quantity: 0 };
            group.commerceItems.push(commerceItem);
            group['quantity'] = group.commerceItems.length;
            groupedCommerceItems.push(group);
          // }
        } else {
          group = { commerceItems: [], quantity: 0 };
          group.commerceItems.push(commerceItem);
          group['quantity'] = group.commerceItems.length;
          groupedCommerceItems.push(group);
        }
      });
    }
    data.items=[];
     groupedCommerceItems = groupedCommerceItems.map(a=>{
      const length = a.commerceItems.length || 0;
      if(a.commerceItems.length > 0){
        a.commerceItems = [{...a.commerceItems && a.commerceItems[0]}] || [];
        a.commerceItems[0].quantity = length;
        data.items.push(a.commerceItems[0]);
      }
      return a;
     });
     data.shipDateAndTime = shoppingCart?.shipDateAndTime || {};
    return data;
  }


  getDeviceInfo(id) {
    return this.http.get(
      `${environment.BASE_URL}/getDeviceSku/${id}`,
      this.httpOptions
    );
  }
  getHighValueConfig (skuId) {
    return this.http.get(
      `${environment.BASE_URL}/getHighValueConfig/${skuId}`,
      this.httpOptions
    );
   }

   getBannerInfo() {
    return this.http.get(
      `${environment.BASE_URL}/getBannerInfo`,
      this.httpOptions
    );
  }

  getProratedDetails(skuId,productType: any) {
    const lang = this.UTS.getLocaleLanguage();
    return this.http.get(
      `${environment.BASE_URL}/skus/proratedDetails/${skuId}?language=${lang}&productType=${productType}`,
       this.httpOptions
    );
  }

}
